/**
 * 包括契約登録API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 包括契約情報
 */
export interface Sgkb709aReqInclusiveCtrInfoDto {
    /**
     * 警告チェック対象外フラグ
     */
    warncheckTargetgaiFlg?: boolean;

    /**
     * 包括契約登録操作コード
     */
    inclusioncontractRegOperationcode?: string;

    /**
     * 登録申請状況コード
     */
    inclusioncontractRegistrationapplicationJokycd?: string;

    /**
     * 解約申請状況コード
     */
    inclusioncontractBreakereqestJokycd?: string;

    /**
     * 契約登録種別コード
     */
    inclusioncontractRegistrationapplicationClscode?: string;

    /**
     * 包括お客さま番号
     */
    inclusioncontractVisitornumber?: string;

    /**
     * 包括契約履歴番号
     */
    inclusioncontractRrkno?: string;

    /**
     * 包括契約年度内通番号
     */
    inclusioncontractYearnaiSrno?: string;

    /**
     * 更新通番号
     */
    updateSrno?: string;

    /**
     * 包括お客さま名
     */
    addrMno?: string;

    /**
     * 住所コード
     */
    addrCode?: string;

    /**
     * 番地・号・分筆号
     */
    pcfdadrChomeKanjiAname?: string;

    /**
     * 住宅・棟号漢字名
     */
    supadrKanjiAname1?: string;

    /**
     * 屋号・業種漢字名
     */
    yagyomoKanji?: string;

    /**
     * 会社グループコード
     */
    companygroupcode?: string;

    /**
     * 契約締結組織番号
     */
    tantoSosikiId?: string;

    /**
     * 契約担当部署
     */
    ctrTantobusho?: string;

    /**
     * 契約締結社員番号
     */
    tantoStaffNo?: string;

    /**
     * 契約締結社員名
     */
    contractdateconclusionStaffname?: string;

    /**
     * 包括お客さま担当部署
     */
    inclusioncontractVisitTantobusho?: string;

    /**
     * 包括お客さま担当者
     */
    inclusioncontractVisitTntsh?: string;

    /**
     * 包括お客さま電話番号
     */
    inclusioncontractVisitTelno?: string;

    /**
     * 契約開始日
     */
    inclusioncontractStartdate?: string;

    /**
     * 包括契約適用年数
     */
    inclusioncontractApplyNumberofyears?: string;

    /**
     * 契約変更適用開始日
     */
    inclusioncontractCtrchgEffectivestartdate?: string;

    /**
     * 契約満了日
     */
    inclusioncontractExpirationdate?: string;

    /**
     * 解約日
     */
    inclusioncontractTerminationdate?: string;

    /**
     * 割引・割増種類
     */
    discountextraSyurui?: string;

    /**
     * メモ
     */
    memo?: string;
}
